import { useMediaQuery } from '@mui/material'
import type { TUserListItem } from '../../../api/types/users'
import { PureLightTheme } from '../../../styles/theme'
import { MobileCard } from './Mobile'
import { DesktopCard } from './Desktop'

type UserItemProps = {
  user: TUserListItem
}

export const UserItem = ({ user }: UserItemProps) => {
  const isMobile = useMediaQuery(PureLightTheme.breakpoints.down("sm"));
  
  return isMobile ? <MobileCard user={user} /> : <DesktopCard user={user} />;
}
